
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { ScrollArea } from '@/components/ui/scroll-area';
import { format } from 'date-fns';

interface EmailLog {
  id: string;
  user_email: string;
  last_login: string;
  login_count: number;
}

interface EmailLogsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const EmailLogsDialog = ({ open, onOpenChange }: EmailLogsDialogProps) => {
  const { data: logs, isLoading } = useQuery({
    queryKey: ['emailLogs'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('user_email_logs')
        .select('*')
        .order('last_login', { ascending: false });

      if (error) throw error;
      return data as EmailLog[];
    },
    enabled: open,
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px]" dir="rtl">
        <DialogHeader>
          <DialogTitle className="text-right">היסטוריית התחברויות</DialogTitle>
        </DialogHeader>
        <ScrollArea className="h-[400px] rounded-md border p-4">
          {isLoading ? (
            <p className="text-center text-muted-foreground">Loading...</p>
          ) : logs?.length === 0 ? (
            <p className="text-center text-muted-foreground">No login history found</p>
          ) : (
            <div className="space-y-4">
              {logs?.map((log) => (
                <div key={log.id} className="flex flex-col space-y-1 border-b pb-2">
                  <div className="flex justify-between items-start">
                    <span className="font-medium">{log.user_email}</span>
                    <span className="text-sm text-muted-foreground">
                      {format(new Date(log.last_login), 'PPp')}
                    </span>
                  </div>
                  <span className="text-sm text-muted-foreground">
                    Login count: {log.login_count}
                  </span>
                </div>
              ))}
            </div>
          )}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
